import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { ExternalLinkModalComponent } from './external-link-modal.component';

@NgModule({
  declarations: [ExternalLinkModalComponent],
  imports: [CommonModule, MatDialogModule],
})
export class ExternalLinkModalModule {}
